import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { Offline, Transaction, ExtraErrorData } from "@sentry/integrations";
import router from "@/router";
import { version } from "../../../package.json";
import type { App } from "@vue/runtime-core";

export default function setupSentry(app: App<Element>) {
  Sentry.init({
    app,
    enabled: false, // import.meta.env.PROD,
    release: 'front-plugin@' + version,
    logErrors: true,
    attachStacktrace: true,
    attachProps: true,
    normalizeDepth: 3,
    tracingOptions: {
      trackComponents: true
    },
    dsn: "https://32c824a68fe746ea9807cfaa8a0762a6@o816514.ingest.sentry.io/6007749",
    integrations: [
      // new Integrations.BrowserTracing({
      //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      //   tracingOrigins: ["localhost", "upclaim.eu"],
      // }),
      new Sentry.Integrations.Breadcrumbs({
        xhr: true,
        fetch: true,
      }),
      new ExtraErrorData({ depth: 2 }),
      new Transaction(),
      new Offline(),
    ],
    tracesSampleRate: 1.0,
  });

  app.config.errorHandler = (err, vm, info) => {
    Sentry.setTag('info', info)
    Sentry.captureException(err)
  }

  window.addEventListener('error', (event) => {
    Sentry.captureException(event)
  });

  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event)
  });
}